import styled from 'styled-components';

const SkeletonFaqStyle = styled.div`
	.image-cont {
		--proportion: 0;

		img {
			position: relative !important;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
`;
export default SkeletonFaqStyle;
